module.exports = __webpack_public_path__ + "static/media/marker-icon-small.34f5b4ac.svg";